import moment, { MomentInput } from "moment-timezone";
import { TIME_FORMAT_12 } from "../../Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-view/components/interval-editor/utils/get12hrTime";

const DATE_FORMAT = "dddd, MMM D ";

export default function formatTimeRange(
  startDate: MomentInput,
  endDate: MomentInput,
  timezone: TimeZone,
) {
  const [startMoment, endMoment] = [startDate, endDate].map((el) =>
    moment.tz(el, timezone),
  );

  const isSameDay = startMoment.isSame(endMoment, "day");

  const startStr = startMoment.format(TIME_FORMAT_12);
  const endStr = isSameDay
    ? endMoment.format(TIME_FORMAT_12)
    : endMoment.format(DATE_FORMAT + TIME_FORMAT_12);

  // omit the same AM/PM if is same day
  if (isSameDay && startStr.slice(-2) === endStr.slice(-2)) {
    return `${startStr.slice(0, -2)} - ${endStr}`;
  }

  return `${startStr} - ${endStr}`;
}
